import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import s from './CreateBlog.module.scss';
import { SecondaryButton } from 'components/SecondaryButton/SecondaryButton';
import { useEffect, useState } from 'react';
import { BlogCard } from '../BlogCard/BlogCard';
import { useSelector } from 'react-redux';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete_icon2.svg"
import DatePicker from 'react-datepicker';
import { Checkbox } from '@mui/material';
import { validationBlog } from 'utils/validation';
import { useStatusContext } from 'components/StatusProvider';
import { useTranslation } from 'react-i18next';
import { useCreateBlogMutation, useDeleteBlogMutation, useGetBlogMutation, useUpdateBlogMutation } from '../../../redux/apis/blogApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ModalGeneral } from 'components/Modals/ModalGeneral';
import questionMark from "assets/images/questionMark.webp";
import { Skeleton } from 'components/Skeleton/Skeleton';
import { TagsSelect } from 'components/TagsSelect/TagsSelect';
const URL = process.env.REACT_APP_API_ADDRESS

export const CreateBlog = () => {

    // ### State
    const [form ,setForm] = useState<any>({
        image: undefined,
        title: undefined,
        body: undefined,
        card_title: undefined,
        card_body: undefined,
        active_card_title: false,
        active_card_body: false,
        author: undefined,
        slug: undefined,
        tags: [],
        date: new Date().toISOString()
    })
    const [showDeleteModal, setShowDeleteModal] = useState<any>(false);
    const langs = useSelector((store: any) => store.main.langs)
    const [lang, setLang] = useState(langs?.[0]?.key)
    const { openStatus } = useStatusContext();
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const id = searchParams.get('id')

    const [DeleteBlog, {isLoading: isDeleteLoading}] = useDeleteBlogMutation()
    const [CreateBlog, {isLoading: isCreateLoading}] = useCreateBlogMutation()
    const [UpdateBlog, {isLoading: isUpdateLoading}] = useUpdateBlogMutation()
    const [GetBlog, {isLoading: isGetBlogLoading}] = useGetBlogMutation()

    // ### Effects
    useEffect(()=>{
        if(id) handleGetBlog(Number(id))
    },[id]);

    // ### Functions

    async function handleDelete(id: number){
        const response = await DeleteBlog({id})
        if(response?.data?.message === "blog_delete_successful"){
            openStatus('success', t(`status.success`))
            navigate('/blog')
        }
        else openStatus('success', "Error")
    }

    async function handleGetBlog(id: number){
        
        const response = await GetBlog({ids: [id]})
        setForm({
            ...response?.data?.[0],
            image: modifyImageData(response?.data?.[0]?.image),
            date: response?.data?.[0]?.date_created
        })
    }

    async function handleCreateBlog(){
        const error = validationBlog(form, langs)
                
        if(error){
            openStatus('error', t(error));
            return
        }

        const action = id ? UpdateBlog : CreateBlog

        const response: any = await action({
            ...form,
            image: modifyImageState(form.image)
        })
        if(response.data?.message === "blog_created_successful" || response.data?.message === "blog_updated_successful"){
            openStatus('success', t(`status.success`))
            navigate(`/blog/create?id=${response?.data?.id}`)
        }
        else openStatus('error', response.error?.data?.message)

    }

    function modifyImageData(image: any){
        return Object.entries(image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${URL?.slice(0, -1)}${el[1]}`
            }
            return acc
        },{})
    }

    function modifyImageState(image: any){
        return Object.entries(image)?.reduce((acc: any, link: any) => {
            if(typeof link[1] === "string") acc[link[0]] = link[1]?.replace(`${URL}`, "/")
                else acc[link[0]] = link[1]
            return acc
        },{})
    }

    // ### Views
    
    return(
        <div className={s.page}>
            <header className={s.header}>
                <span className={s.title}>{id ? t('blog.update') : t('blog.create')}</span>
                <div className={s.buttons}>
                    <PrimaryButton 
                        type={"button"}
                        text={id ? t("general.update") : t("general.save")}
                        onClick={handleCreateBlog}
                        style={{width: "fit-content"}}
                        disabled={isDeleteLoading || isCreateLoading || isUpdateLoading}
                    />
                    <SecondaryButton 
                        type={"button"}
                        text={t('general.back')}
                        onClick={() => navigate('/blog')}
                        style={{width: "fit-content"}}
                    />
                    {   form?.id ?
                        <SecondaryButton
                        text={t('general.delete')}
                            icon={<DeleteIcon/>}
                            type={"button"}
                            style={{width: "fit-content"}}
                            onClick={() => setShowDeleteModal(form.id)}
                            disabled={isDeleteLoading || isCreateLoading || isUpdateLoading}
                        /> : null
                    }
                </div>
            </header>

            <div className={s.card_row}>
                <BlogCard 
                    image={form?.image}
                    title={form.active_card_title ? form?.card_title?.[lang] : form?.title?.[lang]}
                    body={form.active_card_body ? form?.card_body?.[lang] : form?.body?.[lang]}
                    date={form?.date}
                    setForm={setForm}
                />
                <StyledHTMLFieldsBlock 
                    style={{flex: "1 0 auto"}}
                    values={form.card_title}
                    title={t('blog.card_title')}
                    changeValue={(value)=> setForm((prev: any) => ({...prev, card_title: {...prev.card_title, ...value}}))}
                    activeLang={lang}
                    setActiveLang={setLang}
                    setActive={(value: boolean) => setForm((prev: any) => ({...prev, active_card_title: value}))}
                    active={form.active_card_title}
                    height={150}
                />
            </div>
            <StyledHTMLFieldsBlock 
                values={form.card_body}
                title={t('blog.card_body')}
                changeValue={(value)=> setForm((prev: any) => ({...prev, card_body: {...prev.card_body, ...value}}))}
                activeLang={lang}
                setActiveLang={setLang}
                setActive={(value: boolean) => setForm((prev: any) => ({...prev, active_card_body: value}))}
                    active={form.active_card_body}
                height={250}
            />
            <div className={s.row}>
                <div className={s.row_item}>
                    <span className={s.title}>{t('blog.date_publication')}</span>
                    <DatePicker 
                        showTimeSelect
                        dateFormat="dd.MM.yyyy, HH:mm:ss"
                        selected={new Date(form.date)} 
                        onChange={(date: any) => setForm((prev: any) => ({...prev, date: date.toISOString()}))} 
                    />
                </div>
                <div className={s.row_item}>
                    <span className={s.title}>Slug</span>
                    <input 
                        value={form.slug}
                        onChange={(ev) => setForm((prev: any) => ({...prev, slug: ev.target.value}))}
                    />
                </div>
                <div className={s.row_item}>
                    <span className={s.title}>{t('general.author')}</span>
                    <input 
                        value={form.author}
                        onChange={(ev) => setForm((prev: any) => ({...prev, author: ev.target.value}))}
                    />
                </div>
            </div>
            <StyledHTMLFieldsBlock 
                values={form.title}
                title={t('blog.title')}
                changeValue={(value)=> setForm((prev: any) => ({...prev, title: {...prev.title, ...value}}))}
                activeLang={lang}
                setActiveLang={setLang}
                height={150}
            />
            <StyledHTMLFieldsBlock 
                values={form.body}
                title={t('blog.body')}
                changeValue={(value)=> setForm((prev: any) => ({...prev, body: {...prev.body, ...value}}))}
                activeLang={lang}
                setActiveLang={setLang}
                height={350}
            />

            <TagsSelect 
                currentTags={form.tags}
                setCurrentTags={(values: any) => {
                    console.log("values", values);
                    setForm((prev: any) => ({
                        ...prev,
                        tags: values
                    }))
                }}
            />

            <footer className={s.footer}>
                <PrimaryButton 
                    type={"button"}
                    text={id ? t("general.update") : t("general.save")}
                    onClick={handleCreateBlog}
                    style={{width: "fit-content"}}
                    disabled={isDeleteLoading || isCreateLoading || isUpdateLoading}
                />
                <SecondaryButton 
                    type={"button"}
                    text={t('general.back')}
                    onClick={() => navigate('/blog')}
                    style={{width: "fit-content"}}
                />
                {   form?.id ?
                    <SecondaryButton
                    text={t('general.delete')}
                        icon={<DeleteIcon/>}
                        type={"button"}
                        style={{width: "fit-content"}}
                        onClick={() => setShowDeleteModal(form.id)}
                        disabled={isDeleteLoading || isCreateLoading || isUpdateLoading}
                    /> : null
                }
            </footer>

            <Skeleton isLoading={isGetBlogLoading} />

            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                buttonRight={() => handleDelete(showDeleteModal)}
            />

        </div>
    )
}